import { useState } from 'react'
import { GuideDialogShell } from './GuideDialogShell'

const PRODUCT_OVERVIEW_EYEBROW = 'Product overview'

/**
 * Layer A: multi-step product overview on first dashboard visit.
 */
export function ProductGuideDialog({ open, content, onSnooze, onComplete }) {
  const [stepIndex, setStepIndex] = useState(0)

  if (!content?.steps?.length) return null

  const steps = content.steps
  const step = steps[stepIndex]
  const isFirstStep = stepIndex === 0

  const handleClose = () => {
    setStepIndex(0)
    onSnooze()
  }

  const handleFinish = () => {
    setStepIndex(0)
    onComplete()
  }

  return (
    <GuideDialogShell
      open={open}
      eyebrow={isFirstStep ? undefined : PRODUCT_OVERVIEW_EYEBROW}
      title={isFirstStep ? content.title : step.title}
      intro={isFirstStep ? content.lead : undefined}
      stepIndex={stepIndex}
      stepCount={steps.length}
      previewKey={step.previewKey}
      body={step.body}
      onClose={handleClose}
      onBack={stepIndex > 0 ? () => setStepIndex((i) => i - 1) : undefined}
      onNext={() => setStepIndex((i) => Math.min(i + 1, steps.length - 1))}
      onFinish={handleFinish}
      secondaryLabel="Remind me later"
      primaryLabel={stepIndex === steps.length - 1 ? 'Got it' : 'Next'}
    />
  )
}
